import { DeliveryPeriodsByShop, DeliveryPeriodType } from '../../../models';

export const updateShopsWithNowDeliveryPeriod = (
  deliveryPeriodsByShop: DeliveryPeriodsByShop,
) => {
  return Object.keys(deliveryPeriodsByShop).reduce((result, key) => {
    return {
      ...result,
      [key]: {
        ...deliveryPeriodsByShop[key],
        currentDeliveryPeriodType: DeliveryPeriodType.Now,
      },
    };
  }, {} as DeliveryPeriodsByShop);
};
